import { useMutation } from '@apollo/client'
import { BucketShareUpdateDocument } from '../../../graphql/generated'
import logger from '../../../utils/logger'
import useAlerts from './useAlerts'

export default function useBucketShareUpdate() {
  const { createAlert } = useAlerts()
  const [mutation, results] = useMutation(BucketShareUpdateDocument, {
    onError: (e) => {
      e.graphQLErrors.forEach((error) => {
        createAlert(error.message, 'error', error)
      })

      if (!e.graphQLErrors) {
        logger.error(e)
        createAlert('There was a problem updating your share link. Please try again later.')
      }
    }
  })

  return { mutation, results }
}
